import { useState } from "react";
import useSecStackActions from "../../../hooks/actions/sec-stack.actions";

const useDownloadPDFState = (mspId, reportId) => {
  const { getSecStackReportPDF } = useSecStackActions();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const downloadPDF = async (isPrint=false) => {
    if (isPrint) {
      setIsPrinting(true);
    } else {
      setIsDownloading(true);
    }
    await getSecStackReportPDF(mspId, reportId, isPrint);
    setIsDownloading(false);
    setIsPrinting(false);
  }

  return {
    isDownloading,
    isPrinting,
    downloadPDF,
  }
}

export default useDownloadPDFState;